import { useEffect, useReducer, ReactNode } from 'react'
import { Stack, CircularProgress, Typography, Button } from '@mui/material'
import { Error as ErrorIcon } from '@mui/icons-material'
import { Grid } from '.'

interface Props {
    data?: any[]
    loader?: boolean
    children?: ReactNode
    timeoutMessage?: string
    reloadFunction?: () => {}
    customTimeoutMessage?: string
    graphLoad?: boolean
}

const UniversalLoadingCircle: any = ({
    children,
    data = [],
    timeoutMessage = 'There is no data or response from the server, check connection and reload...',
    reloadFunction,
    customTimeoutMessage = '',
    graphLoad,
}) => {
    const defaultState = {
        loading: true,
    }
    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { loading } = state
    const timeoutSeconds = 10
    const timeout = timeoutSeconds * 1000

    const loaderTimeout = () =>
        setTimeout(() => setState({ loading: false }), timeout)

    useEffect(() => {
        if (data.length === 0) {
            loaderTimeout()
        } else {
            setState({ loading: false })
        }
    }, [data])

    const CircularLoadingContainer = () => (
        <Grid
            container
            spacing={0}
            direction="column"
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Grid item xs={12}>
                <Stack
                    sx={{
                        color: 'grey.500',
                        direction: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: 25,
                    }}
                    spacing={2}
                    direction="row"
                >
                    {graphLoad && (
                        <Typography color={'primary'} variant="h4">
                            Generating Charts...
                        </Typography>
                    )}
                    <CircularProgress color="primary" size={100} />
                </Stack>
            </Grid>
        </Grid>
    )

    const TimeoutMessageContainer = () => (
        <Grid
            container
            spacing={0}
            direction="column"
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 25,
            }}
        >
            <Grid item xs={12}>
                <Typography color={'primary'} variant="h4">
                    <Grid container spacing={0.5}>
                        <Grid item xs={2}>
                            <ErrorIcon fontSize="large" sx={{ marginTop: 2 }} />
                        </Grid>
                        <Grid item xs={10}>
                            {customTimeoutMessage
                                ? customTimeoutMessage
                                : timeoutMessage}
                        </Grid>
                    </Grid>
                    {reloadFunction !== undefined && (
                        <Button
                            onClick={() => {
                                reloadFunction()
                                setState({ loading: true })
                                loaderTimeout()
                            }}
                            variant="contained"
                            color="primary"
                            style={{ width: '100%', marginTop: 15 }}
                        >
                            Reload
                        </Button>
                    )}
                </Typography>
            </Grid>
        </Grid>
    )

    return (
        <>
            {(loading && data?.length === 0 && <CircularLoadingContainer />) ||
                (!loading && data?.length === 0 && !graphLoad && (
                    <TimeoutMessageContainer />
                )) ||
                (!loading && data?.length !== 0 && children)}
        </>
    )
}

export default UniversalLoadingCircle
